// extracted by mini-css-extract-plugin
export var banner = "_r2-0";
export var settingRow = "_r2-2";
export var titleIcon = "_r2-1";